

import React from "react";
import image1 from "../../Images/sweepydo_image 20.jpg";
import image4 from "../../Images/sweepydo_image 23.jpg";
import image2 from "../../Images/sweepydo_image17.jpg";
import image5 from  "../../Images/sweepydo_image21.jpg";
import image13 from  "../../Images/sweepydo_image13.jpg";

const About = () => {
  return (
    <>
    
      <section
className="d-flex flex-column flex-md-row align-items-center justify-content-between"
style={{
  minHeight: "260px",
  // height: "220px",
  
  color: "#121313",
  padding: "20px clamp(20px, 5vw, 60px)",
  backgroundImage: `url(${image13})`,
  backgroundSize: "cover",
  backgroundPosition: "center top",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#f5f5f5",
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Montserrat', sans-serif",
  height: "450px",
}}
>
  <div
    style={{
      position: "absolute",
      inset: 0,
   backgroundColor: "rgba(255, 255, 255, 0.45)",
      zIndex: 0,
    }}
  ></div>


  <div
    style={{
      position: "relative",
      zIndex: 1,
      flex: 1,
      textAlign: "center",
      marginBottom: "10px",
    }}
  >
    <h1
      className="fw-bold"
      style={{
        fontSize: "clamp(34px, 4vw, 58px)",
        margin: 0,
        fontWeight: "700",
      }}
    >
      About Us
    </h1>
  </div>

 
  <div
    style={{
      position: "relative",
      zIndex: 1,
      flex: 1,
      textAlign: "center",
    }}
  >
    <div
      style={{
        fontSize: "clamp(14px, 1.2vw, 16px)",
        color: "#555",
        fontWeight: "500",
      }}
    >
      <span
        style={{
          cursor: "pointer",
          color: "#6A20Af",
        }}
        onClick={() => (window.location.href = "/")}
      >
        Home
      </span>{" "}
      &gt; <span>About Us</span>
    </div>
  </div>
</section>

  
      <section
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "60px 20px",
          gap: "50px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1, minWidth: "300px" }}>
          <img
          src={image4}
            // src="https://blog.urbancare.co.nz/wp-content/uploads/House-Cleaning-scaled.jpg"
            alt="Cleaning Service"
            style={{
              width: "100%",
              height: "400px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
        </div>

        <div style={{ flex: 1, minWidth: "300px" }}>
          <h6>Who We Are</h6>
          <h4
            style={{
              marginTop: "15px",
              color: "#000",
              fontFamily: "DM Sans, sans-serif",
              fontSize: "clamp(24px, 2.5vw, 34px)",
              fontWeight: "700",
            }}
          >
            Most Awarded{" "}
            <span style={{ color: "#6A20Af" }}>Cleaning<br />Company</span>{" "}
            Since 1995
          </h4>
          <p style={{ marginTop: "20px", lineHeight: "1.6", color: "#000" }}>
            At vero eos et accusamus et iusto odio dignissimos ducimus qui 
            blanditiis praesentium voluptatum deleniti atque. At vero eos et 
            accusamus et iusto odio dignissimos ducimus qui blanditiis 
            praesentium voluptatum deleniti atque.
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
              gap: "30px",
              marginTop: "30px",
            }}
          >
            <div>
              <h3 className="fw-bold">20K</h3>
              <p>Services Completed</p>
            </div>
            <div>
              <h3 className="fw-bold">4.8/5</h3>
              <p>Customers Rating</p>
            </div>
            <div>
              <h3 className="fw-bold">10M</h3>
              <p>Satisfied Customers</p>
            </div>
            <div>
              <h3 className="fw-bold">10Y</h3>
              <p>Experience</p>
            </div>
          </div>
        </div>
      </section>

<section
  style={{
    backgroundColor: "#e2cce2",
    padding: "60px 20px",
  }}
>
  <div
    style={{
      textAlign: "center",
      maxWidth: "600px",
      margin: "0 auto",
    }}
  >
    <p className="fw-bold">SOME OF OUR FEATURES</p>

    <p
      style={{
        color: "#000",
        marginTop: "15px",
        lineHeight: "1.6",
        fontFamily: "DM Sans, sans-serif",
        fontSize: "clamp(28px, 4vw, 44px)",
        fontWeight: "700",
      }}
    >
      OUR <span style={{ color: "#6A20Af" }}>SERVICES</span> THAT WILL MAKE
      YOUR COMFORT
    </p>
  </div>

  <div
    style={{
      display: "flex",
      gap: "30px",
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: "50px",
      alignItems: "stretch",
    }}
  >
    {[
      {
        img: image1,
        title: "Commercial Cleaning",
      },
      {
        img: image2,
        title: "Window Cleaning",
      },
      {
        img: image5,
        title: "Deep Cleaning",
      },
    ].map((service, index) => (
      <div
        key={index}
        style={{
          flex: "1 1 300px",
          maxWidth: "380px",
          minWidth: "260px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "260px",
            overflow: "hidden",
            borderRadius: "12px",
            background: "#fff",
          }}
        >
          <img
            src={service.img}
            alt={service.title}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        <h5
          className="fw-bold mt-3"
          style={{
            fontSize: "20px",
          }}
        >
          {service.title}
        </h5>
      </div>
    ))}
  </div>
</section>

      <section
        style={{
          padding: "60px 20px",
          backgroundColor: "#f9f9f9",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <p className="fw-bold" style={{ fontSize: "14px", fontFamily: "Open Sans, sans-serif" }}>
            TESTIMONIAL
          </p>
          <h2 style={{ fontWeight: "700", fontSize: "clamp(28px, 4vw, 44px)", color: "#000", fontFamily: "DM Sans, sans-serif" }}>
            We love to hear from our <span style={{ color: "#6A20Af" }}><br/>customers</span>
          </h2>
        </div>

        <div
          style={{
            display: "flex",
            gap: "30px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {[
            {
              img: "https://randomuser.me/api/portraits/men/75.jpg",
              name: "Rohit Sharma",
              desc: "Sweepydo cleaned my apartment perfectly! Very professional and friendly team.",
            },
            {
              img: "https://indianloop.com/desi/images/indianwoman-small.jpg",
              name: "Anjali Verma",
              desc: "The deep cleaning service was amazing! My house feels brand new.",
            },
            {
              img: "https://randomuser.me/api/portraits/men/88.jpg",
              name: "Amit Kumar",
              desc: "Excellent cleaning, very reliable team. I highly recommend Swpeeydo!",
            },
          ].map((testimonial, index) => (
            <div
              key={index}
              style={{
                flex: "1",
                minWidth: "280px",
                backgroundColor: "#fff",
                padding: "25px",
                borderRadius: "10px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                textAlign: "center",
              }}
            >
              <img
                src={testimonial.img}
                alt={testimonial.name}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginBottom: "15px",
                }}
              />
              <p>{testimonial.desc}</p>
              <h6 className="fw-bold mt-3">{testimonial.name}</h6>
            </div>
          ))}
        </div>
      </section>

    </>
  );
};

export default About;